import { Box, Divider } from '@mui/material'
import { LegendToggle } from '@mui/icons-material'
import { Goal, UserSurveyPriority } from 'Generated/graphql-types'
import { WithWidgetLoading } from '../WithWidgetLoading'
import {
  GoalProgressCardsContainer,
  GoalProgressContainer,
} from './GoalProgress.styled'
import { Header } from '../ImpactReportDashboard.styled'
import { DashboardFilters as DashboardFiltersType } from '../types'
import { GoalProgressCard } from './GoalProgressCard'
import { EmptyState } from '../EmptyState/EmptyState'

type GoalProgressProps = {
  filters: DashboardFiltersType
  goals: Goal[]
  loading: boolean
  priorities: UserSurveyPriority[]
}

export const GoalProgress = ({
  filters,
  goals,
  loading,
  priorities,
}: GoalProgressProps) => {
  const filteredGoals = goals.filter((goal) => {
    if (filters.categories.length && goal.category)
      return filters.categories.includes(goal.category)
    if (filters.goalTitleValues.length)
      return filters.goalTitleValues.includes(goal.title)
    return true
  })

  const goalProgressCards = filteredGoals.map((goal, index) => (
    <Box key={goal.id} paddingBottom='8px'>
      <GoalProgressCard goal={goal} userSurveyPriorities={priorities} />
      {index !== filteredGoals.length - 1 && (
        <Divider sx={{ paddingTop: '16px' }} />
      )}
    </Box>
  ))

  const isEmptyState = !loading && (!goals || !goals.length)
  const isLoading = loading || !priorities

  return (
    <WithWidgetLoading
      loading={isLoading}
      width='49.22%'
      height={isEmptyState ? '100%' : '500px'}
    >
      <Header>Goal Progress</Header>
      <GoalProgressContainer>
        {isEmptyState ? (
          <EmptyState
            icon={LegendToggle}
            title='No Progress'
            description='Progress made to each Goal will appear here once you add the first one.'
          />
        ) : (
          <GoalProgressCardsContainer>
            {goalProgressCards}
          </GoalProgressCardsContainer>
        )}
      </GoalProgressContainer>
    </WithWidgetLoading>
  )
}
